<script>
    import { page } from '$app/stores';
    import PageLayout from '$lib/PageLayout.svelte';

    import text404 from '$lib/content/404.md?raw';
    import text403 from '$lib/content/403.md?raw';
    import text401 from '$lib/content/401.md?raw';
    import text500 from '$lib/content/500.md?raw';
    import { marked } from 'marked';
    import Auth from '$lib/Auth.svelte';
    import PageSection from '$lib/PageSection.svelte';
    import Prose from '$lib/Prose.svelte';

    console.error($page.error);

    export const prerender = true;
</script>

<PageLayout>
    <PageSection class="h-full flex flex-col md:flex-row items-center justify-center gap-8 mb-12">
        {#if $page.status === 404}
            <img
                src="/error/lilly_shrug.png"
                alt="Lilly shrug"
                class="w-64 md:order-1"
            />

            <Prose>
                {@html marked(text404)}
            </Prose>
        {:else if $page.status === 403}
            <img
                src="/error/lilly_angry.png"
                alt="Lilly does not approve"
                class="w-64 md:order-1"
            />
            <Prose>
                {@html marked(text403)}
                <Auth
                    ><svelte:fragment slot="button">Log In</svelte:fragment
                    ></Auth
                >
            </Prose>
        {:else if $page.status === 401}
            <img
                src="/error/lilly_angry.png"
                alt="Lilly does not approve"
                class="w-64 md:order-1"
            />
            <Prose>
                {@html marked(text401)}
                <Auth
                    ><svelte:fragment slot="button">Log In</svelte:fragment
                    ></Auth
                >
            </Prose>
        {:else}
            <img
                src="/error/max_lost.png"
                alt="Max is lost"
                class="w-64 md:order-1"
            />
            <Prose>
                {@html marked(text500)}
            </Prose>
        {/if}
    </PageSection>
</PageLayout>
